import { TemperatureCurveFragment } from '../../../generated/graphql'
import { inverseLerp, lerp } from '../../../util/lerp'

export type CurveTemperature = {
  in: number
  return: number
}

export function getTemperaturesFromCurve(
  temperatureCurve: TemperatureCurveFragment,
  outdoorTemperature: number,
): CurveTemperature {
  const rows = temperatureCurve.table

  if (outdoorTemperature <= rows[0].outdoor) {
    // If outdoor temperature outside of range, return start of curve.
    return rows[0]
  }

  if (outdoorTemperature >= rows[rows.length - 1].outdoor) {
    // If outdoor temperature outside of range, return end of curve.
    return rows[rows.length - 1]
  }

  for (let i = 0; i < rows.length - 1; i++) {
    const currentRow = rows[i]
    const nextRow = rows[i + 1]

    if (
      currentRow.outdoor <= outdoorTemperature &&
      outdoorTemperature <= nextRow.outdoor
    ) {
      const t = inverseLerp(
        currentRow.outdoor,
        nextRow.outdoor,
        outdoorTemperature,
      )

      return {
        in: lerp(currentRow.in, nextRow.in, t),
        return: lerp(currentRow.return, nextRow.return, t),
      }
    }
  }

  throw new Error(
    'Should never end up here, is the table sorted from the lowest to the highest temperature?',
  )
}
